import React from 'react';


const columns = [
   
  {
    title: 'User',
    dataIndex: 'userdetail',
  },
  {
    title: 'Login',
    dataIndex: 'loginId',
    key: 'loginId',
    render: (text) => text || '--',
  },
 
  {
    title: 'Symbol',
    dataIndex: 'symbol',
    key: 'symbol',
  },
  {
    title: 'Open Price',
    dataIndex: 'openPrice',
    key: 'openPrice',
    render: (text) => (text !== undefined && text !== null ? text : '--'),
  },
  {
    title: 'Close Price',
    dataIndex: 'closePrice',
    key: 'closePrice',
    render: (text) => (text !== undefined && text !== null ? text : '--'),
  },
  {
    title: 'Open Time',
    dataIndex: 'openTime',
    key: 'openTime',
  },
  {
    title: 'Close Time',
    dataIndex: 'closeTime',
    key: 'closeTime',
  },
  {
    title: 'Trade Duration',
    dataIndex: 'tradeDuration',
    key: 'tradeDuration',
  },
  {
    title: 'Profit',
    dataIndex: 'profit',
    key: 'profit',
    render: (text) => (typeof text === 'number' ? text.toFixed(2) : text || '--'),
  },
  {
    title: 'Group',
    dataIndex: 'groupName',
    key: 'groupName',
  },
  {
    title: 'Threshold',
    dataIndex: 'isThresHold',
    key: 'isThresHold',
  },
  {
    title: 'Threshold Time',
    dataIndex: 'thresHoldTime',
    key: 'thresHoldTime',
  },
          
];

export default columns;
